import * as React from 'react';
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={15} height={14.839} {...props}>
    <g data-name="website 15">
      <path
        fill="#4b8fff"
        d="M3.892 10.764c-1.018.049-2.03.12-3.025.214a7.432 7.432 0 0 1-.868-2.912h3.418a11.652 11.652 0 0 0 .474 2.7"
        data-name="Path 10437"
      />
      <path
        fill="#4b8fff"
        d="M3.418 6.775H0A7.469 7.469 0 0 1 .934 3.74c.993.092 2 .163 3 .209a11.649 11.649 0 0 0-.513 2.826"
        data-name="Path 10438"
      />
      <path
        fill="#4b8fff"
        d="M4.352 12.035a11.683 11.683 0 0 0 1.671 2.768 7.53 7.53 0 0 1-4.334-2.6 70.063 70.063 0 0 1 2.663-.167"
        data-name="Path 10439"
      />
      <path
        fill="#4b8fff"
        d="M4.408 2.677a63.717 63.717 0 0 1-2.618-.16A7.533 7.533 0 0 1 6.023.037a11.651 11.651 0 0 0-1.616 2.64"
        data-name="Path 10440"
      />
      <path
        fill="#4b8fff"
        d="M5.819 2.72a10.412 10.412 0 0 1 1.6-2.326 10.3 10.3 0 0 1 1.608 2.314 62.718 62.718 0 0 1-3.208.012"
        data-name="Path 10441"
      />
      <path
        fill="#4b8fff"
        d="M9.089 12.003a10.345 10.345 0 0 1-1.671 2.441 10.474 10.474 0 0 1-1.665-2.455c1.1-.025 2.22-.021 3.335.013"
        data-name="Path 10442"
      />
      <path
        fill="#4b8fff"
        d="M4.708 8.066h5.41a10.315 10.315 0 0 1-.51 2.662 68.158 68.158 0 0 0-4.382-.016 10.366 10.366 0 0 1-.517-2.646"
        data-name="Path 10443"
      />
      <path
        fill="#4b8fff"
        d="M10.122 6.776H4.708a10.361 10.361 0 0 1 .56-2.775 68.544 68.544 0 0 0 4.296-.014 10.3 10.3 0 0 1 .554 2.79"
        data-name="Path 10444"
      />
      <path
        fill="#4b8fff"
        d="M10.418 2.658A11.676 11.676 0 0 0 8.783.001a7.529 7.529 0 0 1 4.384 2.465c-.912.083-1.831.146-2.75.191"
        data-name="Path 10445"
      />
      <path
        fill="#4b8fff"
        d="M10.477 12.057c.929.044 1.865.11 2.8.2a7.522 7.522 0 0 1-4.5 2.583 11.669 11.669 0 0 0 1.692-2.782"
        data-name="Path 10446"
      />
      <path
        fill="#4b8fff"
        d="M11.416 8.066H15a7.442 7.442 0 0 1-.9 2.969 67.2 67.2 0 0 0-3.165-.249 11.64 11.64 0 0 0 .48-2.72"
        data-name="Path 10447"
      />
      <path
        fill="#4b8fff"
        d="M14.034 3.681A7.471 7.471 0 0 1 15 6.774h-3.584a11.657 11.657 0 0 0-.519-2.849c1.05-.058 2.1-.139 3.137-.244"
        data-name="Path 10448"
      />
      <path
        fill="#64abff"
        d="M3.892 10.764c-1.018.049-2.03.12-3.025.214a7.432 7.432 0 0 1-.868-2.912h3.418a11.652 11.652 0 0 0 .474 2.7"
        data-name="Path 10449"
      />
      <path
        fill="#64abff"
        d="M3.418 6.775H0A7.469 7.469 0 0 1 .934 3.74c.993.092 2 .163 3 .209a11.649 11.649 0 0 0-.513 2.826"
        data-name="Path 10450"
      />
      <path
        fill="#64abff"
        d="M4.352 12.035a11.683 11.683 0 0 0 1.671 2.768 7.53 7.53 0 0 1-4.334-2.6 70.063 70.063 0 0 1 2.663-.167"
        data-name="Path 10451"
      />
      <path
        fill="#64abff"
        d="M3.891 2.654a60.545 60.545 0 0 1-2.1-.137 7.6 7.6 0 0 1 1.226-1.14l.874 1.276Z"
        data-name="Path 10462"
      />
      <path
        fill="#64abff"
        d="M9.089 12.003a10.345 10.345 0 0 1-1.671 2.441 10.474 10.474 0 0 1-1.665-2.455c1.1-.025 2.22-.021 3.335.013"
        data-name="Path 10454"
      />
      <path
        fill="#64abff"
        d="M9.415 10.721a68.394 68.394 0 0 0-4.185-.009 10.381 10.381 0 0 1-.516-2.646h2.883l1.817 2.654Z"
        data-name="Path 10467"
      />
      <path
        fill="#64abff"
        d="M6.713 6.775h-2a10.373 10.373 0 0 1 .413-2.318l1.586 2.317Z"
        data-name="Path 10466"
      />
      <path
        fill="#64abff"
        d="M8.781 14.839a11.674 11.674 0 0 0 1.635-2.654l1.1 1.6a7.441 7.441 0 0 1-2.733 1.053Z"
        data-name="Path 10468"
      />
    </g>
  </svg>
);
export default SvgComponent;
